









































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";

@Component({
  components: {}
})
export default class CardSosial extends Vue {
  get statePasien() {
    return storePasien.identitasPasien;
  }
  getHumanDate(date) {
    return date ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY") : "";
  }
}
